import React from "react";

import { Container } from "reactstrap";
const None = () => (
    <Container fluid className="p-0">
        <h1 className="h3 mb-3">구현 중인 페이지입니다.</h1>
    </Container>
);
export default None;
